import { Minus, Plus, Trash2 } from "lucide-react";
import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { cartSeed, formatVnd } from "../../data/products";
import type { CartLine } from "../../types/domain";

export function CartPage() {
  const [lines, setLines] = useState<CartLine[]>(cartSeed);
  const subtotal = useMemo(
    () => lines.reduce((sum, line) => sum + line.product.price * line.quantity, 0),
    [lines]
  );

  const updateQuantity = (productId: string, delta: number) => {
    setLines((current) =>
      current.map((line) =>
        line.product.id === productId
          ? { ...line, quantity: Math.max(1, line.quantity + delta) }
          : line
      )
    );
  };

  return (
    <main className="page-canvas">
      <section className="container cart-layout">
        <div className="cart-panel">
          <div className="page-title">
            <h1>Giỏ hàng</h1>
            <p>Chọn/xóa, cập nhật số lượng, coupon và tổng tiền như prototype V3.1.</p>
          </div>
          {lines.map((line) => (
            <article className="cart-line" key={line.product.id}>
              <div className="line-art">{line.product.category.slice(0, 2).toUpperCase()}</div>
              <div>
                <strong>{line.product.name}</strong>
                <span>{line.product.id}</span>
              </div>
              <div className="qty">
                <button type="button" onClick={() => updateQuantity(line.product.id, -1)}>
                  <Minus aria-hidden="true" />
                </button>
                <strong>{line.quantity}</strong>
                <button type="button" onClick={() => updateQuantity(line.product.id, 1)}>
                  <Plus aria-hidden="true" />
                </button>
              </div>
              <strong className="line-total">{formatVnd(line.product.price * line.quantity)}</strong>
              <button
                className="icon-button"
                type="button"
                aria-label="Xóa khỏi giỏ"
                onClick={() => setLines((current) => current.filter((item) => item.product.id !== line.product.id))}
              >
                <Trash2 aria-hidden="true" />
              </button>
            </article>
          ))}
        </div>
        <aside className="summary-panel">
          <h2>Tổng đơn</h2>
          <label>
            Mã giảm giá
            <input placeholder="NHAPMA" />
          </label>
          <div className="summary-row">
            <span>Tạm tính</span>
            <strong>{formatVnd(subtotal)}</strong>
          </div>
          <div className="summary-row">
            <span>Vận chuyển</span>
            <strong>Liên hệ</strong>
          </div>
          <div className="summary-total">
            <span>Cần thanh toán</span>
            <strong>{formatVnd(subtotal)}</strong>
          </div>
          <Link className="btn btn-primary" to="/checkout">
            <span>Thanh toán</span>
          </Link>
        </aside>
      </section>
    </main>
  );
}
